import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Ripple } from '../../ripple/ripple.decorator';
import { NavigationCoreItemComponent } from '../navigation-core-item.component';

@Component({
  standalone: false,
  selector: 'campus-navigation-rail-item, [navigation-rail-item]',
  templateUrl: './navigation-rail-item.component.html',
  styleUrls: ['./navigation-rail-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@Ripple({ elementRef: 'iconContainer', triggerRef: 'elementRef', disablePressdown: true })
export class NavigationRailItemComponent extends NavigationCoreItemComponent {
  @HostBinding('class') get hostClasses() {
    return [
      'navigation-rail-item',
      'flex',
      'justify-center',
      'items-center',
      'outline-none',
      this.disabled ? '' : 'cursor-pointer',
      'decoration-none',
      'color-inherit',
      'group',
    ];
  }

  @Input() disabled = false;
}
